import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Text } from "@zorni/components-lib";
import styles from "./ItineraryStepsCard.module.css";

const ItineraryStepsCard = ({
  tripSteps,
  draggedStepIndex,
  setDraggedStepIndex,
  moveStep,
  expandedTripSteps,
  toggleTripStepExpand,
  editStep,
  removeStep,
  trip,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.sectionCard}>
      <div className={styles.sectionTop}>
        <Text as="h3" className={styles.blockTitle} variant="heading" size="lg" weight="bold">
          {t("tripPublication.addTrip.itinerary.title")}
        </Text>
        <Text as="span" className={styles.reorderHint} size="xs" weight="medium" color="muted">
          <Icon name="iconGrid" size="sm" />
          {t("tripPublication.addTrip.itinerary.reorder")}
        </Text>
      </div>

      <div className={styles.stepsContainer}>
        {tripSteps.map((s, idx) => (
          <div
            key={`s-${idx}`}
            className={`${styles.stepItem} ${draggedStepIndex === idx ? styles.dragging : ""}`}
            draggable
            onDragStart={() => setDraggedStepIndex(idx)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => {
              moveStep(draggedStepIndex, idx);
              setDraggedStepIndex(null);
            }}
            onDragEnd={() => setDraggedStepIndex(null)}
          >
            <div className={styles.stepHeader}>
              <div className={styles.stepDragColumn}>
                <Icon name="iconGrid" size="sm" className={styles.dragIcon} />
              </div>
              <div className={styles.stepInfoColumn}>
                <Text as="span" className={styles.stepTitle} weight="bold">
                  #{s?.ranking?.rank || ""} - {s?.ranking?.title || ""}
                </Text>
                <Text as="span" className={styles.stepLocation} size="xs" color="muted">
                  <Icon name="iconLocation" size="md" className={styles.locationIcon} />
                  {s?.city || "-"}, {s?.country || "-"}
                </Text>
              </div>
              <div className={styles.stepActions}>
                <Icon name="iconPenToSquare" size="md" onClick={() => editStep(idx)} />
                <Icon name="iconTrash" size="md" onClick={() => removeStep(idx)} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {tripSteps.length > 0 && (
        <div className={styles.footerActions}>
          <Button
            label={t("tripPublication.addTrip.actions.saveTrip")}
            primary={true}
            className={styles.primaryBtn}
            onClick={handleSubmit}
          />
        </div>
      )}
    </div>
  );
};

export default ItineraryStepsCard;
